import { render, staticRenderFns } from "./copyrightMonitoringUp.vue?vue&type=template&id=311e8bae&scoped=true&"
import script from "./copyrightMonitoringUp.vue?vue&type=script&lang=js&"
export * from "./copyrightMonitoringUp.vue?vue&type=script&lang=js&"
import style0 from "./copyrightMonitoringUp.vue?vue&type=style&index=0&id=311e8bae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311e8bae",
  null
  
)

export default component.exports